import PropTypes from 'prop-types';
import { rgb } from 'd3-color';

const getAngle = (group) => ((group.startAngle + group.endAngle) / 2);

const Groups = ({
    chords,
    color,
    arc,
    outerRadius,
    setMouseOverGroup,
    groupLabels,
    labelColors,
    disableHover,
    hoverPersist,
    setHoverPersist,
    onClick,
}) => (
    <g className="groups">
        {chords.groups.map((group, groupIndex) => (
            <g
                key={groupIndex}
                onMouseOver={(!disableHover && !hoverPersist) ? () => setMouseOverGroup(group.index) : null}
                onMouseOut={(!disableHover && !hoverPersist) ? () => setMouseOverGroup(null) : null}
                onClick={ () => { setHoverPersist(!hoverPersist); onClick && onClick(group.index) } }
            >
                <path
                    fill={`${color(groupIndex)}`}
                    stroke={`${rgb(color(groupIndex)).darker()}`} d={arc(group)}
                />

                <text
                    dy=".35em"
                    transform={`rotate(${getAngle(group) * 180 / Math.PI - 90 }) translate(${outerRadius + 10}) ${getAngle(group) > Math.PI ? "rotate(180)" : ""}`}
                    fill={labelColors.length === 1 ? labelColors[0] : labelColors[groupIndex]}
                    style={{textAnchor: (group.startAngle + group.endAngle) / 2 > Math.PI ? "end" : null}}
                >
                    {groupLabels[groupIndex]}
                </text>
            </g>
        ))}
    </g>
);

Groups.propTypes = {
    chords: PropTypes.array.isRequired,
    color: PropTypes.func.isRequired,
    arc: PropTypes.func.isRequired,
    setMouseOverGroup: PropTypes.func.isRequired,
    groupLabels: PropTypes.array,
    labelColors: PropTypes.array,
    disableHover: PropTypes.bool,
    persistHoverOnClick: PropTypes.bool,
    onClick: PropTypes.func
};

export default Groups;
